import { render } from "./CreateMachineForm.vue?vue&type=template&id=3c13c03e"
import script from "./CreateMachineForm.vue?vue&type=script&lang=js"
export * from "./CreateMachineForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__